import type { RequestConfig } from '@umijs/max';
import { message } from 'antd';
import { clearLoginToken } from '@/services/auth';

export const errorConfig: RequestConfig = {
  errorConfig: {
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) {
        throw error;
      }

      if (error?.response?.status === 401) {
        clearLoginToken();
        return;
      }

      message.error(error?.message || 'Request error, please retry.');
    },
  },
};
